Vendd.Scripts.load(function () {

    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    var $wrapper = $('.promo-popup-container');

    if ($wrapper.length < 1 || !funcCookiesEnabled)
        return;

    InitPromoPopUp();

    function InitPromoPopUp() {
        var cookiesAccepted = window.ConsentsManager.cookiesStatus.userHasSetCookies;
        var promo = Cookies.get('promo-popup');

        if (!promo && cookiesAccepted && $('.terms-page.consents-page').length <= 0) {
            if (!isTouch()) {
                $(".open-promo-popup", $wrapper).fancybox({
                    margin: [20, 0],
                    modal: true,
                    afterClose: function () {
                        Cookies.set("promo-popup", true, { expires: 5, samesite: 'Lax' });
                    }
                });
                $(".open-promo-popup", $wrapper).trigger("click");
                $('.promo-popup .close-button').click(function () {
                    $.fancybox.close(true);
                });
            } else {
                setTimeout(function () {
                    $('.fancy-promo-popup-container').show().addClass('shown');
                }, 2500);
                $('.promo-popup .close-button').click(function () {
                    $('.fancy-promo-popup-container').hide().removeClass('shown');
                    Cookies.set("promo-popup", true, { expires: 5, samesite: 'Lax' });
                });
            }


            $('.promo-popup .button').click(function () {
                $('.fancy-promo-popup-container').hide().removeClass('shown');
                Cookies.set("promo-popup", true, { expires: 5, samesite: 'Lax' });
            });
        }
    }
});
